import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { printsData } from "../components/data/printsData";
import { Link } from "react-router-dom";

const Prints = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [filteredPrints, setFilteredPrints] = useState(printsData);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // Extract unique categories
    const uniqueCategories = [
      "All",
      ...new Set(printsData.map((item) => item.category)),
    ];
    setCategories(uniqueCategories);
  }, []);

  useEffect(() => {
    if (selectedCategory === "All") {
      setFilteredPrints(printsData);
    } else {
      const filtered = printsData.filter((item) =>
        Array.isArray(item.category)
          ? item.category.includes(selectedCategory)
          : item.category.split(", ").includes(selectedCategory)
      );
      setFilteredPrints(filtered);
    }
  }, [selectedCategory]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Prints | BP11 ArtPrints";
  }, []);

  return (
    <Container>
      <div className="title">
        <h1>Moments in Canvases</h1>
        <p>
          Turn your moments into beautiful canvases and make them last forever.
        </p>
      </div>
      <div className="filter-bar">
        {categories.map((category) => (
          <button
            key={category}
            className={selectedCategory === category ? "active" : ""}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>
      <div className="prints">
        {filteredPrints.map((item) => (
          <Link
            to={`/prints/${item.title}`}
            className="link-styles"
            key={item.id}
          >
            <img src={item.image} alt="" />
            <h3>{item.title}</h3>
            <h4>
              Starting at: <h3>$89.99</h3>
            </h4>
          </Link>
        ))}
      </div>
    </Container>
  );
};
const Container = styled.div`
  padding: 7em 7%;
  background-color: var(--primaryBackgroundColor);
  color: var(--fontPrimaryColor);
  .title {
    text-align: center;
    h1 {
      font-size: 5vw;
      font-weight: 300;
    }
    p {
      font-weight: 300;
      color: var(--fontSecondaryColor);
    }
  }
  .filter-bar {
    display: flex;
    justify-content: center;
    gap: 7px 1em;
    max-width: 560px;
    margin: auto;
    margin-top: 2em;
    padding: 7px;
    border-radius: 20px;
    background-color: var(--secondaryBackgroundColor);
    flex-wrap: wrap;
    button {
      padding: 1em;
      font-family: "Comfortaa";
      border-radius: 15px;
      background-color: var(--trPrimaryBackgroundColor);
      color: var(--fontPrimaryColor);
      border: none;
      cursor: pointer;
      &.active {
        background-color: var(--primaryColor);
        color: white;
      }
    }
  }
  .prints {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5em;
    flex-wrap: wrap;
    margin-top: 2em;
    .link-styles {
      width: 300px;
      text-align: center;
      img {
        width: 100%;
      }
      h3 {
        font-weight: 300;
        text-transform: capitalize;
      }
      h4 {
        font-weight: 300;
        color: var(--fontSecondaryColor);
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        h3 {
          color: var(--fontPrimaryColor);
          font-weight: 400;
        }
      }
    }
  }
  @media (max-width: 700px) {
    padding: 5em 5%;
    .title {
      h1 {
        font-size: 3.3em;
        line-height: 0.8em;
      }
    }
  }
`;

export default Prints;
